<script setup>
import { uuid } from '@/helpers'
const props = defineProps({
	count: {
		type: [Number, String],
		default: 0,
	},
	name: {
		type: String,
		default: null,
	},
	type: {
		type: String,
		default: 'checkbox',
	},
	checked: {
		type: Boolean,
		default: false,
	},
})

const id = uuid('badge-')
const emit = defineEmits(['change:input'])

const hover = ref(false)
</script>

<template>
	<label
		:for="id"
		class="badge rounded-pill border d-inline-flex gap-1 cursor-pointer"
		:class="{
			'text-bg-primary': checked,
			'text-bg-neutral-200': !checked && hover,
			'border-primary': checked,
			'text-bg-white': !checked && !hover,
			'border-neutral-500': !checked,
		}"
		@mouseenter="hover = true"
		@mouseleave="hover = false"
	>
		<input
			:id="id"
			:type="type"
			:name="name"
			:checked="checked"
			class="d-none"
			@change="emit('change:input', $event.target.checked)"
		/>
		<span>
			<slot />
		</span>
		<span
			v-if="count"
			class="fs-9 opacity-25"
			>{{ count }}</span
		>
	</label>
</template>
